import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ENVIRONMENT, Environment } from "../auth/auth.tokens";
import { Observable } from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class ActivationService {
    private options: Environment = inject(ENVIRONMENT);
    private apiUrl: string;

    constructor(private http: HttpClient) {
        this.apiUrl = `${this.options.baseUrl.auth}`;
    }

    activate(token: string, password: string): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/auth/activate`, { token, password });
    }

}
